"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _algoliaService = require("@insided/deprecated-services/algoliaService");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _CommunitySearchResults = _interopRequireDefault(require("./CommunitySearchResults"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _AllResults = _interopRequireDefault(require("./AllResults"));

var _LoadingSpinnerV = _interopRequireDefault(require("@insided/destination/icons/LoadingSpinnerV2"));

var _components = require("../../../components");

var _ExternalSearchResults = _interopRequireDefault(require("./ExternalSearchResults"));

var _common = require("@insided/shared/utils/common");

var _SearchService = _interopRequireDefault(require("../../../services/SearchService"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Determines if the search counts are approximate based on Algolia's exhaustive flags.
 * For large datasets, Algolia returns approximate counts for performance.
 */
var isApproximateCount = function isApproximateCount(results) {
  if (!results) return false; // If either nbHits or facet counts are not exhaustive, consider it approximate

  return results.exhaustiveNbHits === false;
};
/**
 * Gets the total topics count, using secondary call data as source of truth
 * when counts are approximate (exhaustiveNbHits: false) on All Results page.
 * @param searchResults - Main search response
 * @param tabFacetsTotal - Total from secondary tab facets call (unfiltered)
 * @param isAllResultsPage - Whether we're on the All Results tab (no source filter)
 */


var getTotalTopicsCount = function getTotalTopicsCount(searchResults, tabFacetsTotal, isAllResultsPage) {
  var _searchResults$nbHits;

  if (!searchResults) return {
    count: 0,
    isApproximate: false
  };
  var isApprox = isApproximateCount(searchResults); // For All Results page with approximate counts, use tabFacetsTotal as source of truth
  // since it represents the unfiltered total across all sources

  if (isApprox && isAllResultsPage && tabFacetsTotal !== undefined && tabFacetsTotal > 0) {
    return {
      count: tabFacetsTotal,
      isApproximate: true
    };
  } // For specific tabs or exact counts, use nbHits from main response


  return {
    count: (_searchResults$nbHits = searchResults.nbHits) !== null && _searchResults$nbHits !== void 0 ? _searchResults$nbHits : 0,
    isApproximate: isApprox
  };
};

var SearchResultsContainer = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchResultsContainer, _Component);

  var _super = _createSuper(SearchResultsContainer);

  function SearchResultsContainer(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchResultsContainer);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "checkForScrollPosition", function () {
      if (!_this.canLoadMore()) return;
      var _this$props = _this.props,
          enableLoader = _this$props.enableLoader,
          searching = _this$props.searching,
          isSearchStalled = _this$props.isSearchStalled;
      if (enableLoader || searching || isSearchStalled) return;
      var searchResults = document.getElementsByClassName('search-result');
      var itemToTriggerPagination = searchResults[searchResults.length - 3];
      if (!itemToTriggerPagination) return;
      var itemToTriggerPaginationBoundaries = itemToTriggerPagination.getBoundingClientRect();

      if (window.innerHeight > itemToTriggerPaginationBoundaries.y) {
        _this.props.loadNextPage();
      }
    });
    _this.getResultsToDisplay = _this.getResultsToDisplay.bind((0, _assertThisInitialized2.default)(_this));
    _this.getZendeskHits = _this.getZendeskHits.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSalesforceHits = _this.getSalesforceHits.bind((0, _assertThisInitialized2.default)(_this));
    _this.getSkilljarHits = _this.getSkilljarHits.bind((0, _assertThisInitialized2.default)(_this));
    _this.getFreshdeskHits = _this.getFreshdeskHits.bind((0, _assertThisInitialized2.default)(_this));
    _this.getCommunityHitForClick = _this.getCommunityHitForClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkForScrollPosition = (0, _debounce.default)(_this.checkForScrollPosition, 150);
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  (0, _createClass2.default)(SearchResultsContainer, [{
    key: "getResultsToDisplay",
    value: function getResultsToDisplay(props) {
      return props.searchResults;
    }
  }, {
    key: "getHitsBySource",
    value: function getHitsBySource(source) {
      var _this$getResultsToDis, _this$getResultsToDis2, _this$getResultsToDis3;

      return (_this$getResultsToDis = (_this$getResultsToDis2 = this.getResultsToDisplay(this.props)) === null || _this$getResultsToDis2 === void 0 ? void 0 : (_this$getResultsToDis3 = _this$getResultsToDis2.hits) === null || _this$getResultsToDis3 === void 0 ? void 0 : _this$getResultsToDis3.filter(function (hit) {
        return hit.gs_data_source === source;
      })) !== null && _this$getResultsToDis !== void 0 ? _this$getResultsToDis : [];
    }
  }, {
    key: "getNumberOfHitsBySource",
    value: function getNumberOfHitsBySource(source) {
      var _this$getResultsToDis4, _this$getResultsToDis5;

      return (_this$getResultsToDis4 = (_this$getResultsToDis5 = this.getResultsToDisplay(this.props)) === null || _this$getResultsToDis5 === void 0 ? void 0 : _this$getResultsToDis5.hits.filter(function (hit) {
        return hit.gs_data_source === source;
      }).length) !== null && _this$getResultsToDis4 !== void 0 ? _this$getResultsToDis4 : 0;
    }
  }, {
    key: "getZendeskHits",
    value: function getZendeskHits() {
      return this.getHitsBySource('zendesk');
    }
  }, {
    key: "getSalesforceHits",
    value: function getSalesforceHits() {
      return this.getHitsBySource('salesforce');
    }
  }, {
    key: "getSkilljarHits",
    value: function getSkilljarHits() {
      return this.getHitsBySource('skilljar');
    }
  }, {
    key: "getFreshdeskHits",
    value: function getFreshdeskHits() {
      return this.getHitsBySource('freshdesk');
    }
  }, {
    key: "getFederatedHits",
    value: function getFederatedHits() {
      return this.getHitsBySource('federated');
    }
  }, {
    key: "getSalesforceNumberOfHits",
    value: function getSalesforceNumberOfHits() {
      return this.getNumberOfHitsBySource('salesforce');
    }
  }, {
    key: "getZendeskNumberOfHits",
    value: function getZendeskNumberOfHits() {
      return this.getNumberOfHitsBySource('zendesk');
    }
  }, {
    key: "getSkilljarNumberOfHits",
    value: function getSkilljarNumberOfHits() {
      return this.getNumberOfHitsBySource('skilljar');
    }
  }, {
    key: "getFreshdeskNumberOfHits",
    value: function getFreshdeskNumberOfHits() {
      return this.getNumberOfHitsBySource('freshdesk');
    }
  }, {
    key: "getFederatedNumberOfHits",
    value: function getFederatedNumberOfHits() {
      return this.getNumberOfHitsBySource('federated');
    }
  }, {
    key: "getCommunityHits",
    value: function getCommunityHits() {
      return this.getHitsBySource('community');
    }
  }, {
    key: "getCommunityNumberOfHits",
    value: function getCommunityNumberOfHits() {
      return this.getNumberOfHitsBySource('community');
    }
  }, {
    key: "hasMorePages",
    value: function hasMorePages(results) {
      return this.props.pageCount < results.nbPages - 1;
    }
  }, {
    key: "canLoadMore",
    value: function canLoadMore() {
      var results = this.getResultsToDisplay(this.props);
      return this.hasMorePages(results);
    }
  }, {
    key: "getCommunityHitForClick",
    value: function getCommunityHitForClick(topicId, idx, queryID) {
      var clickedHit = this.getCommunityHits().filter(function (hit) {
        return hit.id === topicId;
      })[0];

      if (clickedHit) {
        trackEvent(clickedHit, idx, queryID, this.props.communityId, 'community');
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('scroll', this.checkForScrollPosition);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('scroll', this.checkForScrollPosition);
    }
    /**
     * Gets the total count from secondary tab facets call.
     * This represents the unfiltered total across all sources.
     */
    // eslint-disable-next-line class-methods-use-this

  }, {
    key: "getTabFacetsTotal",
    value: function getTabFacetsTotal() {
      return _SearchService.default.tabFacets.reduce(function (acc, tab) {
        return acc + tab.count;
      }, 0);
    }
    /**
     * Gets total topics count with support for approximate counts on large datasets.
     * When Algolia returns non-exhaustive counts (exhaustiveNbHits: false),
     * falls back to secondary call data as source of truth and shows ~ prefix.
     */

  }, {
    key: "getTotalTopics",
    value: function getTotalTopics() {
      if (!_common.common.isModuleActive('unifiedIndexEnabled')) {
        var count = this.getCommunityNumberOfHits() + this.getZendeskNumberOfHits() + this.getSalesforceNumberOfHits() + this.getSkilljarNumberOfHits() + this.getFreshdeskNumberOfHits() + this.getFederatedNumberOfHits();
        return {
          count: count,
          isApproximate: false
        };
      }

      var tabFacetsTotal = this.getTabFacetsTotal();
      return getTotalTopicsCount(this.props.searchResults, tabFacetsTotal, this.props.isAllResultsPage);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          searchResults = _this$props2.searchResults,
          attachmentCdn = _this$props2.attachmentCdn,
          enableLoader = _this$props2.enableLoader,
          pageCount = _this$props2.pageCount,
          totalTopicsAmount = _this$props2.totalTopicsAmount,
          isAllResultsPage = _this$props2.isAllResultsPage,
          onAllResultsSectionClick = _this$props2.onAllResultsSectionClick,
          aiSearchSummary = _this$props2.aiSearchSummary,
          searching = _this$props2.searching,
          isSearchStalled = _this$props2.isSearchStalled,
          timeConfig = _this$props2.timeConfig;

      var _this$getTotalTopics = this.getTotalTopics(),
          totalTopics = _this$getTotalTopics.count,
          isApproximate = _this$getTotalTopics.isApproximate;

      totalTopicsAmount({
        totalTopics: totalTopics,
        zendesk: this.getZendeskNumberOfHits(),
        community: this.getCommunityNumberOfHits(),
        salesforce: this.getSalesforceNumberOfHits(),
        skilljar: this.getSkilljarNumberOfHits(),
        freshdesk: this.getFreshdeskNumberOfHits(),
        federated: this.getFederatedNumberOfHits()
      });
      (0, _insidedDataStorage.setInsidedData)('search', {
        phrase: searchResults === null || searchResults === void 0 ? void 0 : searchResults.query,
        count: totalTopics
      });
      var loading = enableLoader || searching || isSearchStalled;
      return (0, _preact.h)("div", {
        className: "search-results-container unified-index-enabled",
        "aria-live": "polite",
        id: "search-results-container",
        "data-bounded-context": "Search",
        "data-entity": "search-results"
      }, totalTopics === 0 && !loading && (0, _preact.h)(_components.NoSearchResults, null), (0, _preact.h)("div", {
        hidden: totalTopics === 0 && !loading
      }, isAllResultsPage ? (0, _preact.h)("div", {
        className: "all-results-container"
      }, _common.common.isModuleActive('unifiedIndexEnabled') && (0, _preact.h)(ResultsCount, {
        count: totalTopics,
        _isApproximate: isApproximate
      }), (0, _preact.h)(_AllResults.default, {
        loaderCallback: this.props.loaderCallback,
        onClickViewAll: onAllResultsSectionClick,
        clickCallback: function clickCallback(hit, sourceType, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, sourceType);
        },
        timeConfig: timeConfig,
        pageCount: pageCount
      })) : (0, _preact.h)("div", null, (0, _preact.h)(ResultsCount, {
        count: totalTopics,
        _isApproximate: isApproximate
      }), (0, _preact.h)("div", {
        className: "search-topic-list"
      }, (0, _preact.h)(_CommunitySearchResults.default, {
        pageCount: pageCount,
        clickCallback: function clickCallback(topicId, idx) {
          _this2.getCommunityHitForClick(topicId, idx, searchResults.queryID);
        },
        topics: this.getCommunityHits(),
        loaderCallback: this.props.loaderCallback,
        timeConfig: timeConfig
      }), (0, _preact.h)(_ExternalSearchResults.default, {
        clickCallback: function clickCallback(hit, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, 'zendesk');
        },
        hits: this.getZendeskHits(),
        pageCount: pageCount,
        type: "zendesk",
        anchorRel: "noreferrer"
      }), (0, _preact.h)(_ExternalSearchResults.default, {
        clickCallback: function clickCallback(hit, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, 'salesforce');
        },
        hits: this.getSalesforceHits(),
        pageCount: pageCount,
        type: "salesforce",
        itemClass: "thread--unread",
        anchorRel: "noreferrer"
      }), (0, _preact.h)(_ExternalSearchResults.default, {
        clickCallback: function clickCallback(hit, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, 'skilljar');
        },
        hits: this.getSkilljarHits(),
        pageCount: pageCount,
        type: "skilljar",
        anchorRel: "noreferrer"
      }), (0, _preact.h)(_ExternalSearchResults.default, {
        clickCallback: function clickCallback(hit, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, 'freshdesk');
        },
        hits: this.getFreshdeskHits(),
        pageCount: pageCount,
        type: "freshdesk",
        anchorRel: "noreferrer"
      }), (0, _preact.h)(_ExternalSearchResults.default, {
        clickCallback: function clickCallback(hit, idx) {
          trackEvent(hit, idx, searchResults.queryID, _this2.props.communityId, 'federated');
        },
        hits: this.getFederatedHits(),
        pageCount: pageCount,
        type: "federated"
      })), loading && pageCount !== 0 && (0, _preact.h)("div", {
        className: "instant-search-loader_pagination"
      }, (0, _preact.h)(_LoadingSpinnerV.default, {
        width: 30,
        height: 30
      })))));
    }
  }]);
  return SearchResultsContainer;
}(_preact.Component);

var SearchResultsWithMetadata = (0, _connectors.connectStateResults)(SearchResultsContainer);
var _default = SearchResultsWithMetadata;
exports.default = _default;

function trackEvent(item, idx, queryID, indexName, sourceType) {
  (0, _algoliaService.sendClickAnalytic)('Search page item click', item, idx, queryID, indexName, sourceType);
}

function ResultsCount(_ref) {
  var count = _ref.count,
      _ref$_isApproximate = _ref._isApproximate,
      _isApproximate = _ref$_isApproximate === void 0 ? false : _ref$_isApproximate;

  return (0, _preact.h)("div", {
    className: "list__items--meta"
  }, (0, _preact.h)("div", {
    className: "list__items--topic-count"
  }, count, " ", (0, _preact.h)(_phrase.default, {
    p: "Topic|Topics",
    m: "Forum",
    count: {
      value: count.toString()
    }
  })));
}